import {
  Component,
  ElementRef,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  AnalyticsService,
  AuthorizationService,
  ToastrService,
  ExportService,
  LoggingService,
  UsersRemovedData,
  UserRemovedData,
} from "app/shared";
import { BaseChartLogic } from "app/analytics/BaseChartLogic";
import { UsersRemovedConfig } from "app/shared/model/charts/user-analytic-configurations.model";

@Component({
  selector: "users-removed-chart",
  templateUrl: "../../common-chart-template.component.html",
  standalone: false,
})
export class UsersRemovedChartComponent
  extends BaseChartLogic<UsersRemovedConfig, UsersRemovedData>
  implements OnInit, OnDestroy
{
  @Input() startDate: Date | null = null;
  @Input() endDate: Date | null = null;
  @Input() showTitle: boolean = true;
  @ViewChild("chartCanvas") chartCanvas!: ElementRef<HTMLCanvasElement>;

  constructor(
    _analyticsService: AnalyticsService,
    _authService: AuthorizationService,
    _exportService: ExportService,
    _toastrService: ToastrService,
    _loggingService: LoggingService,
    _ngZone: NgZone
  ) {
    super(
      _analyticsService,
      _authService,
      _exportService,
      _toastrService,
      _loggingService,
      UsersRemovedConfig,
      _ngZone
    );
    this.handleDataSubscription(this.analyticsService.usersRemovedDataChange);
  }

  dataPointKey: string = "Total";
  getDataPointDisplayValue(dataPoint: UsersRemovedData): any {
    return dataPoint.Total;
  }

  buildFilterSettings(): void {
    this.addPeriodtoFilterSettings();
    this.addStartEndDatesToFilterSettings(this.startDate, this.endDate);
  }

  refreshData(): void {
    this.analyticsService.getRemovedUsersData(this.filterSettings);
  }

  ngOnInit(): void {
    super.init();
  }

  ngOnDestroy(): void {
    super.cleanup();
  }
}
